<script>
import _ from 'lodash';
import Storage from 'Shared/helpers/storageManager';
import API from '@/utils/api';
import * as Segment from '@/utils/segment';
import { nullable } from '@/utils/propTypes';
import { SHOW_SNACKBAR } from '@/store/types';
import { helpers as notificationHelpers } from '@/store/modules/notifications';

export default {
  props: {
    inviteCode: nullable(String),
    organizationId: nullable(String),
    projectId: nullable(String),
    referralCode: nullable(String),
    teamId: nullable(String),
  },
  data: () => ({
    isLoading: false,
    social: null,
  }),
  methods: {
    ...notificationHelpers.mapActions({ showSnackbar: SHOW_SNACKBAR }),
    handleSignupError(message) {
      this.isLoading = false;
      this.showSnackbar({ message });
    },
    signup() {
      this.isLoading = true;

      const FB = window.FB || {};
      if (!_.isFunction(FB.login)) {
        return this.handleSignupError(
          'Could not connect to Facebook. Please try again later.'
        );
      }

      return FB.login(
        (response) => {
          const { authResponse } = response;

          if (!authResponse) {
            return this.handleSignupError(
              'Please authorize Facebook in order to register on Respondent'
            );
          }

          const opts = {
            fields:
              'id,name,first_name,last_name,email,gender,picture,verified,work,link',
          };

          FB.api('/me', opts, (profile) =>
            this.facebookResponseHandler(profile, authResponse)
          );
        },
        { scope: 'email' }
      );
    },

    async facebookResponseHandler(profile, oauth) {
      try {
        const { error } = await this.userSignup(profile, oauth);
        if (error) {
          return this.handleSignupError(error);
        }

        Storage.participantSignup.setInObject('accountType', 'facebook');
        Storage.participantSignup.setInObject('social', {
          facebook: { profile, oauth },
        });
        Segment.identifyUser(_.get(profile, 'email'));
        Segment.trackParticipant('Participant_Signup_CompleteFacebookConnect', {
          signupType: 'facebook',
        });

        const url = `https://${window.location.host}/respondents/v2/personal?onboarding=true`;
        window.location.assign(url);
      } catch (e) {
        return this.handleSignupError(
          'It looks like you already have a Respondent account for this email. Please sign in instead.'
        );
      }
    },
    async userSignup(profile, oauth) {
      try {
        const {
          data: { success, message, response },
        } = await API.post('v2/user/signup', {
          provider: 'facebook',
          facebook: { profile, oauth },
          organizationId: this.organizationId,
          teamId: this.teamId,
          referralCode: this.referralCode,
          projectId: this.projectId,
          inviteCode: this.inviteCode,
        });

        if (!success) {
          return { error: message };
        }
        if (!response.user) {
          throw new Error();
        }

        return { data: response.user };
      } catch (e) {
        return { error: 'There was a problem signing you up. Please trying again later.' };
      }
    },
  },
};
</script>

<template>
  <v-btn :loading="isLoading" :disabled="isLoading" block outlined @click.exact="signup">
    <v-icon left color="#4569b2" :size="18"> fab fa-facebook-square </v-icon>
    <v-spacer />
    Continue with Facebook
    <v-spacer />
  </v-btn>
</template>
